import Category from "~/components/Processes/conversations/utils/categories.json";

export function getDocumentCategoryCode(doc) {
  if (!doc) return null;
  const cat = doc.category ?? doc?.metadata?.category;
  return typeof cat === "object" ? cat?.code : cat;
}

export function buildCategoryFoldersFromDocuments(
  documents,
  categoryList = Category,
) {
  if (!documents?.length) return [];
  const byCategory = {};
  documents.forEach((doc) => {
    const code = getDocumentCategoryCode(doc);
    if (code) {
      byCategory[code] = (byCategory[code] || 0) + 1;
    }
  });
  return Object.entries(byCategory)
    .filter(([, count]) => count > 0)
    .map(([code]) => {
      const cat = categoryList.find((c) => c.code === code);
      return {
        id: code,
        code,
        name: cat?.name ?? code,
        isCategoryFolder: true,
      };
    });
}
